// Func = limiting Scope for this file
var lastScrollTop = 0;


/* controls video home page	*/
$('#playVideo-js').click(function() {
    let mediaVideo = $("#homeVideo").get(0);
    if (mediaVideo.paused) {
        mediaVideo.play();
    } else {
        mediaVideo.pause();
    }
    $('#playVideo-js').toggleClass('pauseV');
});

(function() {

    $(document).ready(function() {

        /* filter by data-filter from external pages to special page example: /save#specials||wedding-packages */
        var hashArray = location.hash.replace('#', '').split('||');
        if (typeof hashArray == 'object' && hashArray.length > 1) {
            $('ul.section-filter-specials__tags li').filter((i, e) => {
                if ($(e).data('filter') == hashArray[1]) {
                    location.hash = '#' + hashArray[0]
                    $(e).trigger('click')
                }
            });
        }

        //Call function with browser is resized.
        // $(window).resize(function (event) {
        // 	resizeWindow();
        // });
        // resizeWindow();

        // Main Nav Dropdown
        $("#primary-nav li").hover(function() {
            $(this).addClass("hover");
            $('ul.submenu', this).fadeIn(200);
        }, function() {
            $(this).removeClass("hover");
            $('ul.submenu', this).fadeOut(200);
        });

        //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];

        function calendarRange(date) {
            let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
            let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            } else if (date > d1 && date < d2) {
                DATE_STYLE[1] = 'highlight';
            } else {
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }

        //Check in and check out datepicker for booking engine
        const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
        $("#CheckIn").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOut").datepicker("setDate", newDate);
                $("#CheckOut").datepicker("option", "minDate", selectedDate);
            }
        });
        $("#CheckOut").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
            numberOfMonths: 1,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });

        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

        /* funtion */
        $('a.btn, button.btn, button.btn, a.btn-video').filter(function(i, item) {
            let lineText = $(item).text()
            $(item).html(`<svg viewBox="-2 -2 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="black" stroke-width="4">
			<circle cx="40" cy="40" r="40"/>
			</svg>
			<svg viewBox="-2 -2 84 84" class="second-circle" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="black" stroke-width="4">
			<circle cx="40" cy="40" r="40"/>
			</svg>
			<span>${lineText}</span>`)
        });


        var TextSignUpForm = $('button.signup-btn').text();
        $('button.signup-btn').html(`<svg viewBox="-2 -2 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="black" stroke-width="4">
		<circle cx="40" cy="40" r="40"/>
		</svg>
		<svg viewBox="-2 -2 84 84" class="second-circle" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="black" stroke-width="4">
		<circle cx="40" cy="40" r="40"/>
		</svg>
		<span>${TextSignUpForm}</span>`);


        /* funcion to move learn more button on special three quads shortcode*/
        // $(".quad-alternate-dining__description").each( function( index, value ){
        // 	var _this = this;
        // 	$(this).find( "a.btn" ).each( function( index, value ){

        // 		$( _this ).next().prepend(value)

        // 	});
        // });

        /*function button for rooms comparison shortcode */
        $(".quad-room-comparison").hide();
        $(".view-close-btn").hide();

        $('.view-more-btn, .view-close-btn').click(function() {
            $('.quad-room-comparison').slideToggle('slow', function() {
                $('.view-more-btn, .view-close-btn').toggleClass('show-rooms-comparison', $(this).is(':visible'));

                if (!($('.quad-room-comparison').is(":visible"))) {

                    $(".view-more-btn").show();
                    $(".view-close-btn").hide();

                } else {
                    $(".view-more-btn").hide();
                    $(".view-close-btn").show();
                }
            });
        });


        //To create after event 
        $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function(inst) {
            $.datepicker._updateDatepicker_original(inst);
            var afterShow = this._get(inst, 'afterShow');
            if (afterShow)
                afterShow.apply((inst.input ? inst.input[0] : null)); // trigger custom callback
        }



    });

    window.onload = function() {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */

        // scrollDownAction(20, 'scroll');

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();

        })
    };

    /*****************************************************
    		GET WEATHER INFO FROM API
    /*****************************************************/
    if (!(window.ActiveXObject) && "ActiveXObject" in window) {
        //explorer
    } else {

        if (document.getElementById('weather-container')) {

            let weather_grades = document.getElementById('js-weather-grades');
 
            fetch('https://api.openweathermap.org/data/2.5/weather?q=Orlando,us&APPID=0ddd1af8b5b1833cedd6da7a90934cce&units=imperial')
                .then(function(response) {
                    return response.json();
                })
                .then(function(myJson) {
                    weather_grades.innerHTML = parseInt(myJson.main.temp) + '°F';
                });
        }


        //parallax :(
        if (document.getElementsByClassName('parallaxRotation').length > 0) {

            let parallaxoptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            }

            function handlerParallax(entries, observer) {
                for (let entry of entries) {
                    if (entry.isIntersecting) {
                        parallaxRotation(entry.target)
                    } else {
                        let id_elem = entry.target.getAttribute('target-id')
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }

                }
            }
            let allparallax = document.getElementsByClassName('parallaxRotation');
            for (let j = 0; j < allparallax.length; j++) {
                let observerP = new IntersectionObserver(handlerParallax, parallaxoptions)
                observerP.observe(allparallax[j]);
            }

        }

    }


}());

// var isInternalPages = document.querySelector('#home');
// if(isInternalPages){ document.querySelector('a.mouse-scroll').createElement(`<svg viewBox="-2 -2 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="black" stroke-width="4">
// <circle cx="40" cy="40" r="40"/>
// </svg>
// <svg viewBox="-2 -2 84 84" class="second-circle" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="black" stroke-width="4">
// <circle cx="40" cy="40" r="40"/>
// </svg>
// <span></span>`)}

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/* Open and close booking */
// var closeStatus = 'Closed'
// document.querySelector('.book-now-header-js').addEventListener('click', function(){
// 	if (closeStatus== 'Closed'){
// 		document.getElementById('booking-overlay').classList.add('active');
// 		document.querySelector('.book-now-header-js').classList.add('btn-active');
// 		(this).innerHTML = 'Close';
// 		closeStatus = 'Opened'
// 	} else {
// 		document.getElementById('booking-overlay').classList.remove('active');
// 		document.querySelector('.book-now-header-js').classList.remove('btn-active');
// 		(this).innerHTML = 'Reserve';
// 		closeStatus = 'Closed'
// 	}
// });

document.querySelector('.book-now-header-js').addEventListener('click', function() {
    document.getElementById('booking-overlay').classList.add('active');
});

document.querySelector('#booking-overlay .booking-close-js').addEventListener('click', function() {
    document.getElementById('booking-overlay').classList.remove('active');
});


$(".book-room").on('click', function() {
    $('.section-rfp-form').hide(); /*hide*/
    $('.section-calendar').show(); /*show*/
    $('.book-room').addClass('active');
    if ($('.reserve-venue').hasClass('active')) {
        $('.reserve-venue').removeClass('active');
    }
});

$(".reserve-venue").on('click', function() {
    $('.section-rfp-form').show(); /*show*/
    $('.section-calendar').hide(); /*hide*/
    $('.reserve-venue').addClass('active');
    if ($('.book-room').hasClass('active')) {
        $('.book-room').removeClass('active');
    }
});


/* tabs faq */
$('.toggle').click(function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);

    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }

    var arrowAccordion = $this.parent();

    if (arrowAccordion.hasClass('showing-tab')) {
        arrowAccordion.removeClass('showing-tab');

    } else {
        arrowAccordion.addClass('showing-tab');
        //arrowAccordion.addClass('showing-tab');
    }

});